import type { CSSProperties } from 'react';

export const sanitizeColumnIdForCSSVariable = (id: string) =>
  id.replace(/[^a-zA-Z0-9_-]/g, '_');

export const getTableColumnSizeVariable = (column: string) =>
  `--col-${sanitizeColumnIdForCSSVariable(column)}-size`;
export const getTableHeaderSizeVariable = (header: string) =>
  `--header-${sanitizeColumnIdForCSSVariable(header)}-size`;

export const getTableColumnWidth = (column: string) =>
  `calc(var(${getTableColumnSizeVariable(column)}) * 1px)`;
export const getTableHeaderWidth = (column: string) =>
  `calc(var(${getTableHeaderSizeVariable(column)}) * 1px)`;

type TableColumnFixedSizingStyle = Pick<
  CSSProperties,
  'width' | 'maxWidth' | 'minWidth'
>;

export const getTableColumnFixedSizingStyle = (
  columnId: string
): TableColumnFixedSizingStyle => {
  const width = getTableColumnWidth(columnId);

  return {
    width,
    maxWidth: width,
    minWidth: 0,
  };
};

export const getTableHeaderFixedSizingStyle = (
  headerId: string
): TableColumnFixedSizingStyle => {
  const width = getTableHeaderWidth(headerId);

  return {
    width,
    maxWidth: width,
    minWidth: 0,
  };
};

export const getTableColumnBorderVariable = (column: string) =>
  `--col-${sanitizeColumnIdForCSSVariable(column)}-color`;

export const getTableColumnPinLeftVariable = (column: string) =>
  `--col-${sanitizeColumnIdForCSSVariable(column)}-pin-left`;
export const getTableColumnPinRightVariable = (column: string) =>
  `--col-${sanitizeColumnIdForCSSVariable(column)}-pin-right`;

export const getTableColumnPinLeft = (column: string) =>
  `calc(var(${getTableColumnPinLeftVariable(column)}) * 1px)`;
export const getTableColumnPinRight = (column: string) =>
  `calc(var(${getTableColumnPinRightVariable(column)}) * 1px)`;
